window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
    addToCartRedirect: ({ cartItems, discountCode }) => {
      const openCartEvent = new Event("reloadCartAndOpen", { cartItems, discountCode });
      window.dispatchEvent(openCartEvent);
      window.location.assign(`/discount/${discountCode}?redirect=/checkout`);
    }
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");
}

if (window.location.pathname.includes("/tools/bundle-subscriptions")) {
  const awtClubVariantIds = ["43530086383658", "43530086416426", "43530086449194", "43530060595242", "43530061381674", "43530062004266"];
  const awtRemoveLabel = () => ((window.TRANSLATIONS && window.TRANSLATIONS.en && window.TRANSLATIONS.en.translation.titles.remove) || "Remove").trim();
  const awtHideClubRemove = () => {
    awtClubVariantIds.forEach((id) => {
      document.querySelectorAll(`ul[class="gid://shopify/ProductVariant/${id}"] .bundle-button-list-item`).forEach((btn) => {
        if (btn.textContent.trim() === awtRemoveLabel()) {
          const item = btn.closest(".bundle-button-container") || btn;
          item.style.display = "none";
          btn.disabled = true;
        }
      });
    });
  };
  new MutationObserver(awtHideClubRemove).observe(document.body, { childList: true, subtree: true });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return {};

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    return { [babProductId]: bundleSelectedProducts };
  };

  waitForElement(".awtomatic-plans-container", (plansContainer) => {
    if (plansContainer.children.length <= 1) {
      plansContainer.style.display = "none";

      const previousElement = plansContainer.previousElementSibling;
      if (previousElement && previousElement.tagName.toLowerCase() === "span" && previousElement.classList.contains("bundle-text--subheading")) {
        previousElement.style.display = "none";
      }
    }
  });
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});
